var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.996 0C9.418 0 0 9.719 0 21.666c0 10.615 7.379 19.568 17.392 21.35.55 7.635-5.557 14.067-5.622 14.135-.515.552-.631 1.365-.258 2.016.308.53.843.833 1.408.833.132 0 .273-.016.42-.068 29.313-8.4 28.702-36.748 28.651-38.296C41.961 9.698 32.56 0 20.996 0zM91.991 21.636C91.961 9.698 82.558 0 70.996 0 59.418 0 50 9.719 50 21.666c0 10.615 7.379 19.568 17.392 21.35.55 7.635-5.557 14.067-5.622 14.135-.515.552-.631 1.365-.258 2.016.308.53.843.833 1.408.833.132 0 .273-.016.42-.068 29.313-8.4 28.702-36.748 28.651-38.296z"}));
}

Quote.defaultProps = {"viewBox":"0 0 92 60","fill":"currentColor"};

module.exports = Quote;

Quote.default = Quote;
